exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Press{background:#000;padding:70px 0}.PressLogo__column{padding:5px 10px;display:flex;align-items:stretch;flex-wrap:wrap;justify-content:center;min-height:200px}.PressLogo__column{border-left:1px solid #444}.PressLogo__column:last-child{border-right:1px solid #444}.PressLogo__imgWrapper{align-self:center;width:100%;height:100px;margin:50px 0;background-repeat:no-repeat;background-position:center center;background-size:contain}@media screen and (max-width: 90em){.PressLogo__column{padding:10px 30px;min-height:300px}.PressLogo__column:nth-child(2){border-right:1px solid #444}}", ""]);

// exports
